<template>
  <div>
    <q-list bordered separator v-if="issues">
      <q-item
        clickable
        v-ripple
        v-for="issue in orderedIssues"
        :key="'issue' + issue.meta.id"
        @click="openModal(issue.meta.id)"
      >
        <q-item-section avatar>
          <q-btn round color="primary">
            <q-avatar v-if="issueCategory(issue.category.id).img">
              <img
                class="q-pa-sm"
                :src="issueCategory(issue.category.id).img"
                width="40px"
              />
            </q-avatar>
            <q-badge
              floating
              color="negative"
              v-if="issueNotificationsCount(issue.meta.id) > 0"
              >{{ issueNotificationsCount(issue.meta.id) }}</q-badge
            >
          </q-btn>
        </q-item-section>
        <q-item-section>
          <q-item-label>{{ issue.location.place.name }} </q-item-label>
          <q-item-label caption lines="2"
            ><q-icon
              name="person_pin"
              color="warning"
              v-if="issue.meta.isPrivate"
              style="font-size: 20px; padding-right: 5px"
            />
            <q-icon
              v-if="issue.meta.isRequestTenant"
              style="font-size: 20px; padding-right: 5px"
            >
              <img src="~assets/account-arrow-right.svg" color="primary" />
            </q-icon>
            <span v-if="issue.author.id != user.id">
              <i
                >"<u>{{ issue.author.firstName }} {{ $t('common.wrote') }}</u>"</i
              >
              :
            </span>
            {{ issue.content.message }}
          </q-item-label>
        </q-item-section>
        <q-item-section side top class="text-center">
          <q-item-label caption>{{
            $helpers.stringToDate(issue.meta.createdAt)
          }}</q-item-label>
          <q-chip
            dense
            outline
            :color="translateStatus(issue.tracking.status).color"
            class="q-mx-none"
            style="font-size: 11px"
          >
            {{ translateStatus(issue.tracking.status).label }}
          </q-chip>
        </q-item-section>
      </q-item>
    </q-list>
    <div v-else>{{ $t('issueDetails.noIssueToShow') }}</div>
    <q-dialog v-model="opened" maximized ref="modalRef">
      <existing-issue
        :currentIssue="currentIssue"
        :issueId="currentIssue._id"
        :shouldScroll="issueNotificationsCount(currentIssue._id) > 0"
      />
    </q-dialog>
    <q-page-scroller
      position="bottom-right"
      :scroll-offset="150"
      :offset="[18, 18]"
    >
      <q-btn round icon="keyboard_arrow_up" color="accent" />
    </q-page-scroller>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ExistingIssue from 'src/components/issues/Existing'
import eventBus from 'src/eventBus'

export default {
  name: 'IssuesByPlace',
  props: ['issues', 'selectedTab'],
  components: { ExistingIssue },
  inject: ['$DB'],
  data() {
    return {
      currentIssue: null,
      opened: false
    }
  },
  created() {
    eventBus.$on('openModal', this.openModal)
    eventBus.$on('closeIssueModal', this.closeModal)
  },
  mounted() {
    if ('id' in this.$route.params) {
      this.openModal(this.$route.params.id)
    }
  },
  computed: {
    ...mapGetters({
      categories: 'company/categories',
      user: 'reporter/attributes',
      notifications: 'reporter/notifications',
      notificationsSeen: 'reporter/notificationsSeen'
    }),
    orderedIssues() {
      return this.issues.sort((i1, i2) => {
        return new Date(i2['updated-at']) - new Date(i1['updated-at'])
      })
    }
  },
  methods: {
    openModal(issueId) {
      if (this.selectedTab === 'other') {
        this.currentIssue = this.issues.find(
          (issue) => Number(issue.meta.id) === Number(issueId)
        )
        this.opened = true
      } else {
        this.$DB
          .localIssues()
          .get(String(issueId))
          .then((doc) => {
            this.currentIssue = doc
            this.currentIssue = { ...this.currentIssue, fromApi: false }
            this.opened = true
            eventBus.$emit('modalOpened')
          })
      }
    },
    closeModal() {
      if (this.opened) {
        this.opened = false
      }
      this.currentIssue = null
    },
    issueCategory(issueId) {
      let cat = { img: null }
      this.categories.forEach((category) => {
        category.childs.forEach((subcat) => {
          if (subcat.id === Number(issueId)) {
            cat = subcat
          }
        })
      })
      return cat
    },
    issueNotificationsCount(issueId) {
      const notification = this.notifications.filter((notif) => {
        return Number(notif.id) === Number(issueId)
      }).length
      return notification
    },

    translateStatus(status) {
      return this.$helpers.statusTranslation(status)
    }
  }
}
</script>
